/**
 * API Functions
 *
 * @component api
 */

import ClassLogger from 'ClassLogger';

class Api {
    getClassName() { return 'Api'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);
    }

    request(method, uri, data, baseUrl = window.siteconfig.api_baseurl) {
        let self = this;

        if (typeof uri === 'undefined' || uri === '') {
            throw ('endpoint empty or undefined');
        }

        if (uri.charAt(0) === '/') {
            uri = uri.substr(1);
        }
        uri = uri + (uri.indexOf('?') > -1 ? '' : '?');

        if (typeof data === 'undefined' || data === '') {
            data = [];
        }

        if (typeof data !== 'string') data = JSON.stringify(data);
        if (data === '[]') data = null;

        let req = $.ajax({
            url: baseUrl + uri,
            method: method,
            contentType: 'application/json; charset=UTF-8',
            data: data,
            dataType: 'json'
            /*xhrFields: {
                withCredentials: true
            }*/
        });

        req.fail(function (jqXHR, textStatus) {
            self.logger.error('API error (' + jqXHR.status + ')', jqXHR);
        });

        return new Promise(function (resolve, reject) {
            req.then(resolve, reject);
        });
    }

}

export default new Api();
